import { Card, CardProps } from 'antd';
import { clsx } from 'clsx';
import { forwardRef } from 'react';

import s from './AntCard.module.less';

export const AntCard = forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  const { className, ...rest } = props;

  return <Card className={clsx(s.antCard, className)} {...rest} ref={ref} />;
});

AntCard.displayName = 'AntCard';
